"use strict"
const state = {
    filters: {},
    roundings: {},
    originalValues: {}
}

const getters = {
    filters: state => state.filters,
    roundings: state => state.roundings,
    originalValues: state => state.originalValues
}

const actions = {
    addFilterForDevice({commit, state}, obj) {
        let filter = obj.filter;
        let device_id = obj.deviceId
        if (!state.filters[device_id]) {
            commit('addDeviceToFilters', {deviceId: device_id})
        }
        commit('addFilter', {deviceId: device_id, filter: filter})
    },
    getFiltersForDevice({commit, state}, deviceId) {
        return state.filters[deviceId];
    },
    getRoundingsForDevice({commit, state}, deviceId){
        return state.roundings[deviceId];
    },
    removeFilterFromDevice({commit, state}, obj) {
        let filter = obj.filter;
        let device_id = obj.device_id;
        commit('removeFilter', {deviceId: device_id, removed: filter});
    },
    clearEverything({commit, state}) {
        commit('clearFilters');
        commit('clearRoudings')
        commit('clearOriginalValues')
    },
    modifyDatatableDecimals({commit, state}, obj) {
        let type = obj.type
        let device_id = obj.deviceId
        let column = obj.column

        if (!state.roundings[device_id]) {
            commit('addDeviceToRoundings', {deviceId: device_id})
        }
        commit('addRounding', {deviceId: device_id, column: column, type: type})
    },
    addOriginalData({commit, state}, obj) {
        let device_id = obj.id
        if (!state.originalValues[device_id]) {
            commit('addDeviceToOriginalValues', {deviceId: device_id})
        }
        commit('addOriginalValues', {deviceId: device_id, values: obj})
    },
}

const mutations = {
    addDeviceToFilters(state, { deviceId }) {
        state.filters[deviceId] = [];
    },
    addDeviceToRoundings(state, { deviceId }) {
        state.roundings[deviceId] = [];
    },
    addDeviceToOriginalValues(state, { deviceId }) {
        state.originalValues[deviceId] = [];
    },
    addFilter(state, { deviceId, filter }) {
        let temp_array = state.filters;
        state.filters = {};
        temp_array[deviceId].push(filter);
        state.filters = temp_array;
    },
    removeFilter(state, { deviceId, removed }) {
        let temp_array = state.filters;

        state.filters = {};

        temp_array[deviceId] = temp_array[deviceId].filter(row =>
        {
            return !(removed.name === row.name  && removed.operand === row.operand)
        })

        state.filters = temp_array;
    },
    clearFilters(state) {
        state.filters = [];
    },
    addRounding(state, { deviceId, column, type} ){
        let temp_array = state.roundings;
        state.roundings = {};

        let tempObject = {
            columnName: column,
            type: type
        };
        temp_array[deviceId] = tempObject;
        state.roundings = temp_array;
    },
    clearRoundings(state){
        state.roundings = [];
    },
    addOriginalValues(state, { deviceId, values} ){
        let temp_array = state.originalValues;
        state.originalValues = {};
        temp_array[deviceId] = values;
        state.originalValues = temp_array;
    },
    clearOriginalValues(state) {
        state.originalValues = [];
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/app/store/modules/filters.js